/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Antsy_Late_Cat_DevourInputs */

const fr_antsy_late_cat_devour = /** @type {(inputs: Antsy_Late_Cat_DevourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**

* @param {Antsy_Late_Cat_DevourInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const antsy_late_cat_devour = /** @type {((inputs?: Antsy_Late_Cat_DevourInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Antsy_Late_Cat_DevourInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_antsy_late_cat_devour(inputs)
});